module.exports = __webpack_public_path__ + "img/Thais.3fef0132.jpg";